import {
  Table,
  TableHeader,
  TableBody,
  TableColumn,
  TableRow,
  TableCell,
} from '@heroui/react'
import {
  DS_TYPOGRAPHY_BODY_MD_MEDIUM,
  DS_TYPOGRAPHY_TITLE_SM,
} from '@shared/ui'

export const AxisTable = ({
  headers = null,
  items = [],
  noItemsText = 'No hay items que mostrar',
}) => {
  if (!items.length) {
    return <div className="text-center">{noItemsText}</div>
  }

  return (
    <Table
      classNames={{
        wrapper:
          'shadow-none border-1 border-generic-neutral-200 rounded-lg p-2 md:p-4',
        th: `${DS_TYPOGRAPHY_TITLE_SM} bg-generic-neutral-200 h-[64px] px-4 !text-generic-neutral-900`,
        td: `${DS_TYPOGRAPHY_BODY_MD_MEDIUM} min-h-[48px] p-4 text-generic-neutral-900`,
        tr: 'border-b border-generic-neutral-200 last:border-none md:border-none',
        thead: '[&>tr]:border-none',
      }}
    >
      <TableHeader>
        {headers.map((header, index) => (
          <TableColumn key={index}>{header}</TableColumn>
        ))}
      </TableHeader>
      <TableBody>
        {items.map((item, index) => (
          <TableRow key={index}>
            {item.map((itemValue, ix) => (
              <TableCell key={ix}>{itemValue}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
